import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { IKeycloakTeam } from 'pages/superAdmin/TeamAccess';
import GroupAPI from 'api/GroupAPI';

interface IArchivedTeamsProps {
  teams: any;
  activateTeam: any;
}

const ArchivedTeams: React.FC<IArchivedTeamsProps> = (props: IArchivedTeamsProps) => {
  const { teams, activateTeam } = props;
  const [ archivedTeams, setArchivedTeams ] = useState<IKeycloakTeam[]>([]);
  const archived: IKeycloakTeam[] = [];
  const filterTeams = async(teamsFromProps: IKeycloakTeam[]) => {
    await Promise.all(
      teamsFromProps.map(async(team: IKeycloakTeam) => {
        const res = await GroupAPI.getGroupById(team.id);
        if (res?.success) {
          const currentTeam = res.result;
          if (currentTeam.realmRoles?.includes('archived') && !currentTeam.realmRoles?.includes('service-account')) {
            archived.push(currentTeam);
          }
        }
      })
    );
    setArchivedTeams(archived);
  };
  useEffect(() => {
    filterTeams(teams);
  }, [ teams ]);
  return (
    <Grid item xs={12} lg={6} md={6} sm={6}>
      {archivedTeams.map((team: IKeycloakTeam, index: number) => {
        return (
          <div key={index}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className='team-box'>
                <div>
                  <Link to={`/team/${team.id}`}>
                    <Typography className='text-white team-name' variant='h6' component='h2'>
                      {team.name}
                    </Typography>
                  </Link>
                </div>
                <div>
                  <Button className='Theme-Btn' onClick={() => activateTeam(team.id, team.name)}>
                    Set Active
                  </Button>
                </div>
              </div>
            </Grid>
          </div>
        );
      })
      }
    </Grid>
  );
};

export default ArchivedTeams;
